


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export default class InputElement extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: String, required: false }) readonly id!: string;
  @Prop({ type: String, required: false }) readonly value!: string;
  @Prop({ type: String, required: false }) cssClass!: string;
  @Prop({ type: String, required: false }) inputCssClass!: string;
  @Prop({ type: String, required: false }) containerInputCssClass!: string;
  @Prop({ type: Number, default: Infinity }) readonly maxCharacters!: number;

  get inputListeners() {
    return {
      ...this.$listeners,
      input: (event: any) => {
        let inputValue = event.target.value;

        // Tronca il valore se supera il limite di caratteri
        if (inputValue && inputValue.length > this.maxCharacters) {
          inputValue = inputValue.slice(0, this.maxCharacters);
        }

        this.$emit("input", event.target.value);
      },
    };
  }
}
